<script>
    import { loggedInUserStore } from "./store/loggedInUser.js";
    import { langTextStore } from "./store/langtexts.js";
    import LangSelector from "./SharedComponents/LangSelector.svelte";
    import { fade, fly } from "svelte/transition";
    import { cubicOut, cubicIn, sineOut } from "svelte/easing";

    let email = "";
    if (!(window.location.href.indexOf("resetpassword") > 0)) {
        try {
            email =
                localStorage.getItem("loggedInUser") &&
                JSON.parse(localStorage.getItem("loggedInUser")).email;
        } catch (s) {}
    }
    let password = "";
    let mode = "login";
    let country = "";
    let functionName = "";
    let organizationType = "";
    var countries = [
        { name: "Choose" },
        { name: "Afghanistan" },
        { name: "Åland Islands" },
        { name: "Albania" },
        { name: "Algeria" },
        { name: "American Samoa" },
        { name: "Andorra" },
        { name: "Angola" },
        { name: "Anguilla" },
        { name: "Antarctica" },
        { name: "Antigua and Barbuda" },
        { name: "Argentina" },
        { name: "Armenia" },
        { name: "Aruba" },
        { name: "Australia" },
        { name: "Austria" },
        { name: "Azerbaijan" },
        { name: "Bahamas" },
        { name: "Bahrain" },
        { name: "Bangladesh" },
        { name: "Barbados" },
        { name: "Belarus" },
        { name: "Belgium" },
        { name: "Belize" },
        { name: "Benin" },
        { name: "Bermuda" },
        { name: "Bhutan" },
        { name: "Bolivia (Plurinational State of)" },
        { name: "Bonaire, Sint Eustatius and Saba" },
        { name: "Bosnia and Herzegovina" },
        { name: "Botswana" },
        { name: "Bouvet Island" },
        { name: "Brazil" },
        { name: "British Indian Ocean Territory" },
        { name: "United States Minor Outlying Islands" },
        { name: "Virgin Islands (British)" },
        { name: "Virgin Islands (U.S.)" },
        { name: "Brunei Darussalam" },
        { name: "Bulgaria" },
        { name: "Burkina Faso" },
        { name: "Burundi" },
        { name: "Cambodia" },
        { name: "Cameroon" },
        { name: "Canada" },
        { name: "Cabo Verde" },
        { name: "Cayman Islands" },
        { name: "Central African Republic" },
        { name: "Chad" },
        { name: "Chile" },
        { name: "China" },
        { name: "Christmas Island" },
        { name: "Cocos (Keeling) Islands" },
        { name: "Colombia" },
        { name: "Comoros" },
        { name: "Congo" },
        { name: "Congo (Democratic Republic of the)" },
        { name: "Cook Islands" },
        { name: "Costa Rica" },
        { name: "Croatia" },
        { name: "Cuba" },
        { name: "Curaçao" },
        { name: "Cyprus" },
        { name: "Czech Republic" },
        { name: "Denmark" },
        { name: "Djibouti" },
        { name: "Dominica" },
        { name: "Dominican Republic" },
        { name: "Ecuador" },
        { name: "Egypt" },
        { name: "El Salvador" },
        { name: "Equatorial Guinea" },
        { name: "Eritrea" },
        { name: "Estonia" },
        { name: "Ethiopia" },
        { name: "Falkland Islands (Malvinas)" },
        { name: "Faroe Islands" },
        { name: "Fiji" },
        { name: "Finland" },
        { name: "France" },
        { name: "French Guiana" },
        { name: "French Polynesia" },
        { name: "French Southern Territories" },
        { name: "Gabon" },
        { name: "Gambia" },
        { name: "Georgia" },
        { name: "Germany" },
        { name: "Ghana" },
        { name: "Gibraltar" },
        { name: "Greece" },
        { name: "Greenland" },
        { name: "Grenada" },
        { name: "Guadeloupe" },
        { name: "Guam" },
        { name: "Guatemala" },
        { name: "Guernsey" },
        { name: "Guinea" },
        { name: "Guinea-Bissau" },
        { name: "Guyana" },
        { name: "Haiti" },
        { name: "Heard Island and McDonald Islands" },
        { name: "Holy See" },
        { name: "Honduras" },
        { name: "Hong Kong" },
        { name: "Hungary" },
        { name: "Iceland" },
        { name: "India" },
        { name: "Indonesia" },
        { name: "Côte d'Ivoire" },
        { name: "Iran (Islamic Republic of)" },
        { name: "Iraq" },
        { name: "Ireland" },
        { name: "Isle of Man" },
        { name: "Israel" },
        { name: "Italy" },
        { name: "Jamaica" },
        { name: "Japan" },
        { name: "Jersey" },
        { name: "Jordan" },
        { name: "Kazakhstan" },
        { name: "Kenya" },
        { name: "Kiribati" },
        { name: "Kuwait" },
        { name: "Kyrgyzstan" },
        { name: "Lao People's Democratic Republic" },
        { name: "Latvia" },
        { name: "Lebanon" },
        { name: "Lesotho" },
        { name: "Liberia" },
        { name: "Libya" },
        { name: "Liechtenstein" },
        { name: "Lithuania" },
        { name: "Luxembourg" },
        { name: "Macao" },
        { name: "Macedonia (the former Yugoslav Republic of)" },
        { name: "Madagascar" },
        { name: "Malawi" },
        { name: "Malaysia" },
        { name: "Maldives" },
        { name: "Mali" },
        { name: "Malta" },
        { name: "Marshall Islands" },
        { name: "Martinique" },
        { name: "Mauritania" },
        { name: "Mauritius" },
        { name: "Mayotte" },
        { name: "Mexico" },
        { name: "Micronesia (Federated States of)" },
        { name: "Moldova (Republic of)" },
        { name: "Monaco" },
        { name: "Mongolia" },
        { name: "Montenegro" },
        { name: "Montserrat" },
        { name: "Morocco" },
        { name: "Mozambique" },
        { name: "Myanmar" },
        { name: "Namibia" },
        { name: "Nauru" },
        { name: "Nepal" },
        { name: "Netherlands" },
        { name: "New Caledonia" },
        { name: "New Zealand" },
        { name: "Nicaragua" },
        { name: "Niger" },
        { name: "Nigeria" },
        { name: "Niue" },
        { name: "Norfolk Island" },
        { name: "Korea (Democratic People's Republic of)" },
        { name: "Northern Mariana Islands" },
        { name: "Norway" },
        { name: "Oman" },
        { name: "Pakistan" },
        { name: "Palau" },
        { name: "Palestine, State of" },
        { name: "Panama" },
        { name: "Papua New Guinea" },
        { name: "Paraguay" },
        { name: "Peru" },
        { name: "Philippines" },
        { name: "Pitcairn" },
        { name: "Poland" },
        { name: "Portugal" },
        { name: "Puerto Rico" },
        { name: "Qatar" },
        { name: "Republic of Kosovo" },
        { name: "Réunion" },
        { name: "Romania" },
        { name: "Russian Federation" },
        { name: "Rwanda" },
        { name: "Saint Barthélemy" },
        { name: "Saint Helena, Ascension and Tristan da Cunha" },
        { name: "Saint Kitts and Nevis" },
        { name: "Saint Lucia" },
        { name: "Saint Martin (French part)" },
        { name: "Saint Pierre and Miquelon" },
        { name: "Saint Vincent and the Grenadines" },
        { name: "Samoa" },
        { name: "San Marino" },
        { name: "Sao Tome and Principe" },
        { name: "Saudi Arabia" },
        { name: "Senegal" },
        { name: "Serbia" },
        { name: "Seychelles" },
        { name: "Sierra Leone" },
        { name: "Singapore" },
        { name: "Sint Maarten (Dutch part)" },
        { name: "Slovakia" },
        { name: "Slovenia" },
        { name: "Solomon Islands" },
        { name: "Somalia" },
        { name: "South Africa" },
        { name: "South Georgia and the South Sandwich Islands" },
        { name: "Korea (Republic of)" },
        { name: "South Sudan" },
        { name: "Spain" },
        { name: "Sri Lanka" },
        { name: "Sudan" },
        { name: "Suriname" },
        { name: "Svalbard and Jan Mayen" },
        { name: "Swaziland" },
        { name: "Sweden" },
        { name: "Switzerland" },
        { name: "Syrian Arab Republic" },
        { name: "Taiwan" },
        { name: "Tajikistan" },
        { name: "Tanzania, United Republic of" },
        { name: "Thailand" },
        { name: "Timor-Leste" },
        { name: "Togo" },
        { name: "Tokelau" },
        { name: "Tonga" },
        { name: "Trinidad and Tobago" },
        { name: "Tunisia" },
        { name: "Turkey" },
        { name: "Turkmenistan" },
        { name: "Turks and Caicos Islands" },
        { name: "Tuvalu" },
        { name: "Uganda" },
        { name: "Ukraine" },
        { name: "United Arab Emirates" },
        { name: "United Kingdom of Great Britain and Northern Ireland" },
        { name: "United States of America" },
        { name: "Uruguay" },
        { name: "Uzbekistan" },
        { name: "Vanuatu" },
        { name: "Venezuela (Bolivarian Republic of)" },
        { name: "Viet Nam" },
        { name: "Wallis and Futuna" },
        { name: "Western Sahara" },
        { name: "Yemen" },
        { name: "Zambia" },
        { name: "Zimbabwe" },
    ];

    let step = "step1";
    let token = "";
    let acceptTerms = false;
    let errormessage = "";
    if (window.location.href.indexOf("resetpassword") > 0) {
        mode = "forgotpassword";
        step = "step2";
        email = getParameterByName("email");
        token = getParameterByName("token");
    }
    if (window.location.href.indexOf("register") > 0) {
        mode = "register";
        step = "step2";
        email = getParameterByName("email");
        token = getParameterByName("token");
    }
    var y = getParameterByName("email");
    async function login() {
        errormessage = "";

        email = email.trim();
        if (email.length == 0) {
            alert($langTextStore.getText("general-warning-email-required"));
            return;
        }
        var result = await loggedInUserStore.login(email, password);
        if (!result.success) {
            errormessage = $langTextStore.getText(result.errormessage);
        }
    }

    function getParameterByName(name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return "";
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }
    async function registerstep1() {
        if (!acceptTerms) {
            errormessage = $langTextStore.getText("please-accept-terms");
            return;
        }
        errormessage = "";
        email = email.trim();
        if (email.length == 0) {
            alert($langTextStore.getText("general-warning-email-required"));
            return;
        }
        var result = await loggedInUserStore.registerstep1({
            email: email,
            functionName,
            country,
            organizationType,
        });
        if (!result.success) {
            errormessage = $langTextStore.getText(result.errormessage);
            return;
        }
        mode = "registersent";
    }
    async function registerstep2() {
        errormessage = "";
        email = email.trim();
        if (email.length == 0) {
            alert($langTextStore.getText("general-warning-email-required"));
            return;
        }
        var result = await loggedInUserStore.registerstep2(
            email,
            password,
            token
        );
        mode = "login";
        step = "step1";
        errormessage = $langTextStore.getText("general-label-account-created");
        if (!result.success) {
            errormessage = $langTextStore.getText(result.errormessage);
        }
    }

    async function forgotpasswordstep1() {
        errormessage = "";
        email = email.trim();
        if (email.length == 0) {
            alert($langTextStore.getText("general-warning-email-required"));
            return;
        }
        var result = await loggedInUserStore.forgotpasswordstep1(email);
        if (!result.success) {
            errormessage = $langTextStore.getText(result.errormessage);
            return;
        }
        mode = "forgotpasswordsent";
    }
    async function forgotpasswordstep2() {
        errormessage = "";
        email = email.trim();
        if (email.length == 0) {
            alert($langTextStore.getText("general-warning-email-required"));
            return;
        }
        var result = await loggedInUserStore.forgotpasswordstep2(
            email,
            password,
            token
        );
        if (!result.success) {
            errormessage = $langTextStore.getText(result.errormessage);
        } else {
            mode = "login";
            step = "step1";
            login();
        }
    }
    function checkEnter(e) {
        if (e.code == "Enter" || e.key == "Enter") {
            if (mode == "login") login();
            else register();
        }
    }
    let visible = false;
    window.setTimeout(() => (visible = true), 100);
</script>

<LangSelector
    extraClass="lang-switcher-dashboard"
    langs={$langTextStore.allLangs}
    showChoice={false}
    on:langChosen={() => {}}
/>

{#if visible}
    <div
        class="container align-vertical-middle"
        in:fly={{ y: 250, duration: 1600, easing: sineOut }}
        out:fade={{ duration: 200 }}
    >
        <div class="row" in:fade={{ delay: 800 }}>
            <div class="w-100 text-center">
                <img
                    src="/img/logo.svg"
                    id="logo"
                    style="max-width: 200px;"
                    class="w-md-100 w-100 "
                    alt={$langTextStore.getText("general-label-app-title")}
                    title={$langTextStore.getText("general-label-app-title")}
                />
            </div>
            <div class="col-12 offset-md-3 col-md-6">
                <div class="innner_modal box-shadow">
                    {#if mode == "forgotpasswordsent"}
                        <h2
                            class="gray-6 mb-3 pe-md-5 ps-md-5 mt-3  text-center"
                            in:fade
                        >
                            {@html $langTextStore.getText(
                                "general-label-reset-password-mail-sent-header"
                            )}
                        </h2>
                        <div class="mb-5 text-gray-6 text-center">
                            {$langTextStore.getText(
                                "general-label-reset-password-mail-sent-explanation"
                            )}
                        </div>
                    {/if}
                    {#if mode == "registersent"}
                        <h2
                            class="gray-6 mb-3 pe-md-5 ps-md-5 mt-3  text-center"
                            in:fade
                        >
                            {@html $langTextStore.getText(
                                "general-label-register-mail-sent-header"
                            )}
                        </h2>
                        <div class="mb-5 text-gray-6 text-center">
                            {$langTextStore.getText(
                                "general-label-register-mail-sent-explanation"
                            )}
                        </div>
                    {/if}
                    {#if mode == "login"}
                        <h2
                            class="gray-6 mb-3 pe-md-5 ps-md-5 mt-3  text-center"
                            in:fade
                        >
                            {@html $langTextStore.getText(
                                "general-label-welcome-product-calculator"
                            )}
                        </h2>
                        <div class="mb-5 text-gray-6 text-center">
                            {$langTextStore.getText(
                                "general-label-do-you-want-register"
                            )}
                            <span
                                class="c-pointer line inline-block font-primary"
                                in:fade
                                on:click={() => {
                                    mode = "register";
                                    step = "step1";
                                }}
                            >
                                {$langTextStore.getText(
                                    "general-label-click-here"
                                )}</span
                            >
                        </div>
                    {/if}
                    {#if mode == "register"}
                        <h2 class="gray-6 mt-3" in:fade>
                            {@html $langTextStore.getText(
                                "general-label-welcome-product-calculator-register"
                            )}
                        </h2>
                    {/if}
                    {#if mode == "forgotpassword"}
                        <h2 class="gray-6 mt-3" in:fade>
                            {@html $langTextStore.getText(
                                "general-label-welcome-product-calculator-forgot-password"
                            )}
                        </h2>
                    {/if}

                    {#if mode == "forgotpassword" && step == "step2"}
                        <p>
                            {$langTextStore.getText(
                                "general-text-enter-token-and-password"
                            )}
                        </p>
                    {/if}
                    {#if mode == "register" && step == "step2"}
                        <p>
                            {$langTextStore.getText(
                                "general-text-enter-token-and-password-to-register"
                            )}
                        </p>
                    {/if}
                    {#if mode == "register" && step == "step1"}
                        <label
                            in:fade
                            for="country"
                            style="  text-transform: capitalize; "
                            >{$langTextStore.getText(
                                "general-label-country"
                            )}</label
                        >
                        <select
                            in:fade
                            name="country"
                            type="text"
                            bind:value={country}
                        >
                            {#each countries as countryOption}<option
                                    value={countryOption.name}
                                    >{countryOption.name}</option
                                >
                            {/each}
                        </select>
                        <label
                            in:fade
                            for="organizationType"
                            style="  text-transform: capitalize; "
                            >{$langTextStore.getText(
                                "general-label-organization-type"
                            )}</label
                        >
                        <select
                            in:fade
                            name="organizationType"
                            type="text"
                            bind:value={organizationType}
                        >
                            <option value="">choose</option>
                            <option>brand</option>
                            <option> factory</option>
                            <option> NGO</option>
                            <option> union</option>
                            <option> academia/research</option>
                            <option> employers’ association</option>
                            <option> Multi Stakeholder Initiative</option>
                            <option> other</option>
                        </select>
                        <label
                            in:fade
                            for="function"
                            style="  text-transform: capitalize; "
                            >{$langTextStore.getText(
                                "general-label-function"
                            )}</label
                        >
                        <input
                            in:fade
                            name="function"
                            type="text"
                            bind:value={functionName}
                            on:keypress={checkEnter}
                        />
                    {/if}
                    {#if mode != "forgotpasswordsent" && mode != "registersent"}
                        <label
                            in:fade
                            for="email"
                            style="  text-transform: capitalize; "
                            >{$langTextStore.getText(
                                "general-label-email"
                            )}</label
                        >
                        <input
                            in:fade
                            name="email"
                            type="text"
                            bind:value={email}
                            on:keypress={checkEnter}
                        />
                    {/if}
                    {#if mode == "login"}
                        <label
                            in:fade
                            for="password"
                            style="  text-transform: capitalize; "
                            >{$langTextStore.getText(
                                "general-label-password"
                            )}</label
                        >
                    {/if}
                    {#if step == "step2"}
                        <label
                            in:fade
                            for="password"
                            style="  text-transform: capitalize; "
                            >{$langTextStore.getText(
                                "general-label-new=password"
                            )}</label
                        >
                        <input
                            name="disable-pwd-mgr-1"
                            type="password"
                            id="disable-pwd-mgr-1"
                            style="display: none;"
                            value="disable-pwd-mgr-1"
                        />
                        <input
                            name="disable-pwd-mgr-2"
                            type="password"
                            id="disable-pwd-mgr-2"
                            style="display: none;"
                            value="disable-pwd-mgr-2"
                        />
                        <input
                            name="disable-pwd-mgr-3"
                            type="password"
                            id="disable-pwd-mgr-3"
                            style="display: none;"
                            value="disable-pwd-mgr-3"
                        />
                    {/if}
                    {#if mode == "login" || step == "step2"}
                        <input
                            in:fade
                            name="password"
                            type="password"
                            data-lpignore="true"
                            bind:value={password}
                            on:keypress={checkEnter}
                        />
                    {/if}

                    {#if false && step == "step2"}
                        <label
                            in:fade
                            for="token"
                            style="  text-transform: capitalize; "
                            >{$langTextStore.getText(
                                "general-label-token"
                            )}</label
                        >
                        <input
                            in:fade
                            name="token"
                            type="text"
                            bind:value={token}
                            on:keypress={checkEnter}
                        />
                    {/if}
                    {#if mode == "register" && step == "step1"}
                        <label>
                            <input type="checkbox" bind:value={acceptTerms} />
                            {@html $langTextStore.getText(
                                "general-label-acceptterms"
                            )}
                        </label>
                    {/if}
                    <div class="float-end">
                        {#if mode == "login"}
                            <button
                                in:fade
                                class="btn btn-primary width-unset mb-2 mt-4"
                                on:click={login}
                                >{$langTextStore.getText(
                                    "general-label-login"
                                )}</button
                            >
                        {/if}
                        {#if mode == "forgotpassword" && step == "step1"}
                            <button
                                in:fade
                                class="btn btn-primary width-unset mb-2 mt-4"
                                on:click={forgotpasswordstep1}
                                >{$langTextStore.getText(
                                    "general-label-forgot-send"
                                )}</button
                            >
                        {/if}
                        {#if mode == "forgotpassword" && step == "step2"}
                            <button
                                in:fade
                                class="btn btn-primary width-unset mb-2 mt-4"
                                on:click={forgotpasswordstep2}
                                >{$langTextStore.getText(
                                    "general-label-reset-password"
                                )}</button
                            >
                        {/if}
                        {#if mode == "register" && step == "step1"}
                            <button
                                in:fade
                                class="btn btn-primary width-unset mb-2 mt-4"
                                on:click={registerstep1}
                                >{$langTextStore.getText(
                                    "general-label-register"
                                )}</button
                            >
                        {/if}

                        {#if mode == "register" && step == "step2"}
                            <button
                                in:fade
                                class="btn btn-primary width-unset"
                                on:click={registerstep2}
                                >{$langTextStore.getText(
                                    "general-label-register-step2"
                                )}</button
                            >
                        {/if}
                    </div>

                    <div class="mt-4 mb-3">
                        {#if mode == "login"}
                            <div class="text-small">
                                {$langTextStore.getText(
                                    "general-label-forgot-password-question"
                                )}
                                <span
                                    class="c-pointer line inline-block font-primary"
                                    in:fade
                                    on:click={() => {
                                        (mode = "forgotpassword"),
                                            (errormessage = "");
                                    }}
                                >
                                    {$langTextStore.getText(
                                        "general-label-click-here"
                                    )}
                                </span>
                            </div>
                        {/if}

                        {#if mode != "login"}
                            <span
                                class="c-pointer line  p-2 inline-block  font-primary text-small"
                                in:fade
                                on:click={() => {
                                    (mode = "login"),
                                        (step = "step1"),
                                        (errormessage = "");
                                }}
                            >
                                {$langTextStore.getText(
                                    "general-label-back-to-login"
                                )}
                            </span>
                        {/if}
                    </div>
                    {#if errormessage.length > 0}
                        <div class="error " transition:fade>{errormessage}</div>
                    {/if}

                    <div
                        style="position:relative;top:20px;width:100%;display:flex; justify-content: space-around;"
                    >
                        <div>
                            <a href="privacy.pdf" style="font-size:1rem;">
                                {$langTextStore.getText(
                                    "general-privacy-statement"
                                )}</a
                            >
                            -
                            <a href="terms.pdf" style="font-size:1rem;">
                                {$langTextStore.getText("general-terms")}</a
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
{/if}
<svelte:head>
    <style>
        body {
            background: #ed003b;
        }
        .lang-switcher-dashboard.lang-switcher .selector,
        .text-gray-5 {
            color: #fff;
        }
    </style>
</svelte:head>
